import { TableDomain } from "_components/Abstractions/TableDomain";
import { stringToDate } from "../../../domain/Configuration";

export function QuickWeighedWasteTable({ items, selectedItems, onSelectedItemsChanged }) {
  const keyColumn = "id";
  const columns = [
    {
      name: "id",
      headerName: "Nr. ważenia",
    },
    {
      name: "date",
      headerName: "Data ważenia",
      map: (x) => stringToDate(x.date),
    },
    {
      name: "weight",
      headerName: "Masa [kg]",
    }
  ];

  const props = {
    keyColumn,
    columns,
    items,
    multiSelect: true,
    onSelectedItemsChanged,
    selectedItems,
  };

  return <TableDomain {...props} />;
}
